import React from 'react';
import { IMAGES, LINKS, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { locations } from '../data/locations';
const serviceLinks = [{
  label: 'Auto Glass',
  href: LINKS.auto
}, {
  label: 'Windshield Chip Repair',
  href: LINKS.chip
}, {
  label: 'ADAS Calibration',
  href: LINKS.adas
}, {
  label: 'Residential Glass',
  href: LINKS.residential
}, {
  label: 'Glass Shower Doors',
  href: LINKS.shower
}, {
  label: 'Commercial Glass',
  href: LINKS.commercial
}];
const supportLinks = [{
  label: 'Glass Resources & Guides',
  href: LINKS.resources
}, {
  label: 'Emergency Auto Glass',
  href: LINKS.emergencyAuto
}, {
  label: 'Contact Kosin’s Glass',
  href: LINKS.contact
}, {
  label: 'Locations & hours',
  href: '#locations'
}];
export function Footer() {
  return <footer className="w-full bg-kosin-charcoal" data-id="element-63" data-mp="29z6v4e3aingy">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-16" data-id="element-64" data-mp="29ydxq3q81abh">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-65" data-mp="2eyjqjn8892v5">
          <div data-id="element-66" data-mp="3l9abve5p2w2b">
            <div className="inline-block rounded bg-white px-3 py-2" data-id="element-67" data-mp="3l8qwo57filrz">
              <img src={IMAGES.logo} alt="Kosin’s Glass" width={227} height={95} className="h-[54px] w-auto" data-id="element-68" data-mp="3gah1hulpfl6d" />
            </div>
            <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-69" data-mp="3q8dkf8kvvkf1">
              Family-owned glass company serving Southeast Michigan since 2000.
            </p>
            <a href={PHONE_HREF} className="focus-light mt-3 inline-block text-[17px] font-semibold text-white hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-70" data-mp="33xe1y3atysi">
              {PHONE_DISPLAY}
            </a>
          </div>

          <nav aria-label="Services" data-id="element-71" data-mp="cvtng5au5bc1">
            <h2 className="text-[13px] font-semibold uppercase text-white/60" data-id="element-72" data-mp="qt05tyrnd80q">
              Services
            </h2>
            <ul className="mt-3 space-y-2 text-[15px]" data-id="element-73" data-mp="msxzvdevpsfn">
              {serviceLinks.map(link => <li key={link.label} data-id="element-74" data-mp="tw618ehn64qf">
                  <a href={link.href} className="focus-light text-white/80 hover:text-white transition-colors duration-150 ease-kosin" data-id="element-75" data-mp="tt0bcx16uytn">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Resources and contact" data-id="element-76" data-mp="1clm8rlrquxgc">
            <h2 className="text-[13px] font-semibold uppercase text-white/60" data-id="element-77" data-mp="1cl2t6bpkgl5h">
              Resources &amp; contact
            </h2>
            <ul className="mt-3 space-y-2 text-[15px]" data-id="element-78" data-mp="1hmife73hcxpg">
              {supportLinks.map(link => <li key={link.label} data-id="element-79" data-mp="1riv6qybjyzh1">
                  <a href={link.href} className="focus-light text-white/80 hover:text-white transition-colors duration-150 ease-kosin" data-id="element-80" data-mp="1rhtuwrmpq8y9">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-81" data-mp="2afwzir5zft1r">
            <h2 className="text-[13px] font-semibold uppercase text-white/60" data-id="element-82" data-mp="2agew5owk49a7">
              Offices
            </h2>
            <ul className="mt-3 space-y-4 text-[15px] text-white/80" data-id="element-83" data-mp="25mkdmosou0cp">
              {locations.map(office => <li key={office.city} data-id="element-84" data-mp="1wnyyl3mfd3go">
                  <p className="font-semibold text-white" data-id="element-85" data-mp="1wp0a197crryx">
                    {office.city}
                    {!office.isPrimary && <span className="ml-1.5 text-[12px] font-medium uppercase text-white/50" data-id="element-86" data-mp="2tbn4mn97p5jv">
                        Satellite
                      </span>}
                  </p>
                  <address className="not-italic leading-relaxed" data-id="element-87" data-mp="2kf4fzn80k3t3">
                    {office.address.map(line => <span key={line} className="block" data-id="element-88" data-mp="18ynupd9s2syb">
                        {line}
                      </span>)}
                  </address>
                  <a href={office.phoneHref} className="focus-light hover:text-white transition-colors duration-150 ease-kosin" data-id="element-89" data-mp="1414ei7tis63q">
                    {office.phoneDisplay}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-12 border-t border-white/10 pt-6 text-[14px] text-white/50" data-id="element-90" data-mp="2ntmg2mwbc3vv">
          © {new Date().getFullYear()} Kosin’s Glass. All rights reserved.
        </p>
      </div>
    </footer>;
}